import { useMutation, useQueryClient } from "react-query";
import { toast } from 'react-toastify';
import { SrxApi } from '../api/SrxApi';

const useEditVersion = (setSelectedVersion, setIsModalOpen) => {
  const queryClient = useQueryClient();

  const { mutate: editVersion, isLoading } = useMutation(
    async ({ payload }) => {
      if (!payload.Id) {
        throw new Error('Version ID is required for editing');
      }
      const response = await SrxApi.post(`/versions/create-or-edit`, payload);
      return response?.data;
    },
    {
      onSuccess: (data) => {
        if (data) {
          setSelectedVersion(null);
          setIsModalOpen(false);
          toast.success(data?.message || "Version updated successfully!");
          queryClient.invalidateQueries(["getAllVersion"]);
          queryClient.invalidateQueries(["currentVersion"]);
        }
      },
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to update version";
        toast.error(errorMessage);
      },
    }
  );

  return { editVersion, isEditVersionLoading: isLoading };
};

export default useEditVersion;